export const BankTab = ({ state, errors, handleInputChange, handleTabChange }) => {
    return (
        <div className="tab-pane fade show active">
            <div className="row">
                <div className="col-md-6">
                    <div className="form-group mb-3">
                        <label>Bank Name *</label>
                        <input
                            type="text"
                            className={`form-control ${errors.bank_name ? 'is-invalid' : ''}`}
                            placeholder="Enter bank name"
                            name="bank_name"
                            value={state.bank_name}
                            onChange={handleInputChange}
                            required
                        />
                        {errors.bank_name && <div className="invalid-feedback">{errors.bank_name}</div>}
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="form-group mb-3">
                        <label>Account Number *</label>
                        <input
                            type="text"
                            className={`form-control ${errors.account_number ? 'is-invalid' : ''}`}
                            placeholder="Enter account number"
                            name="account_number"
                            value={state.account_number}
                            onChange={handleInputChange}
                            required
                        />
                        {errors.account_number && <div className="invalid-feedback">{errors.account_number}</div>}
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-md-6">
                    <div className="form-group mb-3">
                        <label>Bank Address *</label>
                        <textarea
                            className={`form-control ${errors.bank_address ? 'is-invalid' : ''}`}
                            placeholder="Enter bank address"
                            rows="3"
                            name="bank_address"
                            value={state.bank_address}
                            onChange={handleInputChange}
                            required
                        ></textarea>
                        {errors.bank_address && <div className="invalid-feedback">{errors.bank_address}</div>}
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="form-group mb-3">
                        <label>Contact Person *</label>
                        <input
                            type="text"
                            className={`form-control ${errors.contact_person ? 'is-invalid' : ''}`}
                            placeholder="Enter contact person"
                            name="contact_person"
                            value={state.contact_person}
                            onChange={handleInputChange}
                            required
                        />
                        {errors.contact_person && <div className="invalid-feedback">{errors.contact_person}</div>}
                    </div>
                </div>
            </div>

            <div className="d-flex justify-content-end align-items-start gap-3 mt-4">
                <button
                    type="button"
                    className="btn btn-dark mr-3 btn-sm"
                    onClick={() => handleTabChange("trade")}
                >
                    Back
                </button>
                <button type="button" className="btn btn-info ms-auto btn-sm" onClick={() => handleTabChange("credit")}>
                    Next
                </button>
            </div>
        </div>
    );
};